export const GROUPED_VIDEOS_LIST = {
  groupOrder: [
    'overviewGroup',
    'flowGuidesGroup',
    'connectorsGroup',
    'monitorGroup',
    'transformGroup',
    'collaborateGroup',
    'miscGroup',
    // 'lookupGroup'
  ],
  groupRules: {
    overviewGroup: {
      index: 'overviewGroup',
      displayName: 'Overview',
      optionsOrder: [
        'gettingStarted',
        'integrateOverview',
        'monitoringFlows',
        'nexsetDesignerOverview',
        'resourceSearch',
      ],
    },
    flowGuidesGroup: {
      index: 'flowGuidesGroup',
      displayName: 'Quick Start',
      optionsOrder: [
        'gettingStarted',
        'directFlowGuide',
        'ragFlowGuide',
        'eltFlowGuide',
        'byoFlowGuide',
        'replicationFlowGuide',
        'dbCdcFlowGuide',
        'sparkEtlFlowGuide',
        'privateDataProductMarketplace',
      ],
    },
    connectorsGroup: {
      index: 'connectorsGroup',
      displayName: 'Integrate',
      optionsOrder: [
        'integrateOverview',
        'flowVisOrchestration',
        'bidirectional',
        'restIngest',
        'nexsetGsheetsApp',
        'catalogAlation',
        'tableauDestination',
        'usingLookups',
        'branchingDataflows',
        'dbAsService',
      ],
    },
    monitorGroup: {
      index: 'monitorGroup',
      displayName: 'Monitor',
      optionsOrder: ['monitoringFlows', 'flowInsights'],
    },
    collaborateGroup: {
      index: 'collaborateGroup',
      displayName: 'Collaborate',
      optionsOrder: ['shareCred', 'shareFlow', 'shareData'],
    },
    transformGroup: {
      index: 'transformGroup',
      displayName: 'Transform',
      optionsOrder: [
        'nexsetDesignerOverview',
        'txPreBuilt',
        'txCustom',
        'txMask',
        'enrichingWithAPI',
        'txReusable',
      ],
    },
    miscGroup: {
      index: 'miscGroup',
      displayName: 'Use Cases',
      optionsOrder: ['freshserviceSync', 'cli', 'jenkins', 'usingEmailConnector'],
    },
  },
  videoItems: {
    gettingStarted: {
      index: 'gettingStarted',
      videoId: '868958392/51f92e7e3a',
      displayName: 'Getting Started with Nexla',
      url: 'https://vimeo.com/868958392/51f92e7e3a',
      thumbnail:
        'https://i.vimeocdn.com/video/1890755924-70925297bd3a5c9f98ae9f3dab46d0815779c5485ce32a098ea5b6b7eb273038-d?mw=1200&mh=675&q=70',
      duration: '10:05 mins',
    },
    integrateOverview: {
      index: 'integrateOverview',
      videoId: '871257336',
      displayName: 'Integrate: Overview & Features',
      url: 'https://vimeo.com/871257336',
      thumbnail:
        'https://i.vimeocdn.com/video/1733684811-50a37d42effc9a677d9cbb70ba9938302649fb295b826125afcb43988629662a-d',
      duration: '4:32 mins',
    },
    bidirectional: {
      index: 'bidirectional',
      videoId: '567183625',
      displayName: 'No-Code, Bidirectional Connectors',
      url: 'https://vimeo.com/567183625',
      thumbnail:
        'https://i.vimeocdn.com/video/1172651032-85f246b908eee5c311b0b09c8ad67c40dae5942d5dd5fae08578a37da6984cf3-d?mw=1500&mh=844&q=70',
      duration: '03:21 mins',
    },
    restIngest: {
      index: 'restIngest',
      videoId: '478686909',
      displayName: 'API Sources: Basic and Advanced',
      url: 'https://vimeo.com/478686909',
      thumbnail:
        'https://i.vimeocdn.com/video/993811554-6c1aa4249c6a7daf8cb8d9fc1f00e85f8d1446bc756319f8bde1b33b5bcad451-d?mw=1500&mh=844&q=70',
      duration: '08:04 mins',
    },
    nexsetGsheetsApp: {
      index: 'nexsetGsheetsApp',
      videoId: '464306866',
      displayName: 'Get Real-time data in Google Sheets',
      url: 'https://vimeo.com/464306510',
      thumbnail:
        'https://i.vimeocdn.com/video/968273874-449513fe659f503237d3f904fecc4e47da18bf755eb6dc9ce2c488ccd71e8eec-d?mw=1500&mh=844&q=70',
      duration: '03:48 mins',
    },
    catalogAlation: {
      index: 'catalogAlation',
      videoId: '464034972/79d4e02de8',
      displayName: 'Catalog any data in Alation',
      url: ' https://vimeo.com/464034972/79d4e02de8',
      thumbnail:
        'https://i.vimeocdn.com/video/967810094-646a01a4d1d801f53f56eb7a051b2ff0c7b83310ca18569b219c5f4f57c74601-d?mw=1500&mh=844&q=70',
      duration: '03:59 mins',
    },
    tableauDestination: {
      index: 'tableauDestination',
      videoId: '450265901/3ff5a35cc3',
      displayName: 'Tableau Destination',
      url: 'https://vimeo.com/450265901/3ff5a35cc3',
      thumbnail:
        'https://i.vimeocdn.com/video/944363797-1f5c06d795883c46c2a5cd42767b3357b57e98c224e856d17330f1b41830871d-d?mw=1300&mh=731&q=70',
      duration: '06:04 mins',
    },
    usingLookups: {
      index: 'usingLookups',
      videoId: '574531387',
      displayName: 'Creating & Using Data Lookups',
      url: 'https://vimeo.com/574531387',
      thumbnail:
        'https://i.vimeocdn.com/video/1723998490-a1b2f00d69ccf7e1ab4c2f85e1800020a02f02b77ad408d07b76edfe29092e0f-d',
      duration: '05:10 mins',
    },
    branchingDataflows: {
      index: 'branchingDataflows',
      videoId: '569552488',
      displayName: 'Branching Dataflows',
      url: 'https://vimeo.com/569552488',
      thumbnail:
        'https://i.vimeocdn.com/video/1177790558-e2de865fe40bec161a6b3e45ceabd3d7f4b2cac5b56534a0c13d64338835fef9-d?mw=1500&mh=844&q=70',
      duration: '04:37 mins',
    },
    dbAsService: {
      index: 'dbAsService',
      videoId: '568663553',
      displayName: 'Database as a Service',
      url: 'https://vimeo.com/568663553',
      thumbnail:
        'https://i.vimeocdn.com/video/1218173681-6823fe02f78376bdb0d19dc7a3c7dafaa08a10140ebc816c6fa5b7339923d31a-d?mw=1500&mh=844&q=70',
      duration: '06:00 mins',
    },
    monitoringFlows: {
      index: 'monitoringFlows',
      videoId: '869265295/19924bc489',
      displayName: 'Monitor: Overview & Features',
      url: 'https://vimeo.com/869265295/19924bc489',
      thumbnail:
        'https://i.vimeocdn.com/video/1730720709-f455302b5c371f6d51d2e2e75d131af5e4e244d19fc0b9d5ca3113ce846b4339-d',
      duration: '03:33 mins',
    },
    freshserviceSync: {
      index: 'freshserviceSync',
      videoId: '472827984',
      displayName: 'Automatic Ticket Sync on FreshService and FreshDesk',
      url: 'https://vimeo.com/472827984',
      thumbnail:
        'https://i.vimeocdn.com/video/983432664-b38cfa3b291caa38eb090d63cdf4ab329c29ea8c800093138ef7c0e270949b52-d?mw=1500&mh=844&q=70',
      duration: '04:38 mins',
    },
    shareCred: {
      index: 'shareCred',
      videoId: '560143238',
      displayName: 'Sharing Account Credentials',
      url: 'https://vimeo.com/560143238',
      thumbnail:
        'https://i.vimeocdn.com/video/1157899418-d58ea72237feb6f2316740d1256ff0f5dc9ee2b103e698d98d2400caee59311e-d?mw=1500&mh=844&q=70',
      duration: '04:04 mins',
    },
    shareFlow: {
      index: 'shareFlow',
      videoId: '560523326',
      displayName: 'Sharing Data and Dataflows',
      url: 'https://vimeo.com/560523326',
      thumbnail:
        'https://i.vimeocdn.com/video/1158663841-27f96f4215a4936cf1822e9389c02483a4102b8d8ed163f887e0b047c2d7af85-d?mw=1500&mh=844&q=70',
      duration: '05:28 mins',
    },
    shareData: {
      index: 'shareData',
      videoId: '555368439',
      displayName: 'Sharing Data with Partners',
      url: 'https://vimeo.com/555368439',
      thumbnail:
        'https://i.vimeocdn.com/video/1147711508-b6b6c16c155497de441d7eedd964d13378ebaf95e96a825b840bb6b88a0673a5-d?mw=1500&mh=844&q=70',
      duration: '06:31 mins',
    },
    txMask: {
      index: 'txMask',
      videoId: '536514978',
      displayName: 'Data Masking for PII by Hashing',
      url: 'https://vimeo.com/536514978',
      thumbnail:
        'https://i.vimeocdn.com/video/1110664238-cb35501e5cfa1308637c485f1380710e112f9ee0db8c73c6ae80f4c29fe989df-d?mw=1500&mh=844&q=70',
      duration: '06:44 mins',
    },
    txPreBuilt: {
      index: 'txPreBuilt',
      videoId: '868035169/2b17e619da',
      displayName: 'Using Pre-Built Transforms',
      url: 'https://vimeo.com/868035169/2b17e619da',
      thumbnail:
        'https://i.vimeocdn.com/video/1729006847-1300c6e2b5031a2d3a79242604e1ce2d296b668d6dca45045b908b19c1f2dea7-d',
      duration: '07:33 mins',
    },
    txCustom: {
      index: 'txCustom',
      videoId: '782354147',
      displayName: 'Using Custom Transforms',
      url: 'https://vimeo.com/782354147',
      thumbnail:
        'https://i.vimeocdn.com/video/1570761012-7252d75361eb3ddb653e89d1bb7891dcd7b98c2ea22896b500358fac5a6ef1a0-d_1920x1080',
      duration: '03:44 mins',
    },
    enrichingWithAPI: {
      index: 'enrichingWithAPI',
      videoId: '574530160/fe41b9b532',
      displayName: 'Enriching Data with API Calls',
      url: 'https://vimeo.com/574530160/fe41b9b532',
      thumbnail:
        'https://i.vimeocdn.com/video/1188273901-94a769366eec5f80b77055c48fc2628fc1f6bb8c4248b745bda72686c7083b22-d?mw=1300&mh=731&q=70',
      duration: '00:05 mins',
    },
    txReusable: {
      index: 'txReusable',
      videoId: '574530993/55fa060d7e',
      displayName: 'Reusable Transforms',
      url: 'https://vimeo.com/574530993/55fa060d7e',
      thumbnail:
        'https://i.vimeocdn.com/video/1188273346-c166b9b7067e4065043455169e28edc0bf6b3522a671dceb13ee3737353bcade-d?mw=1500&mh=844&q=70',
      duration: '07:00 mins',
    },
    cli: {
      index: 'cli',
      videoId: '566261796',
      displayName: 'Nexla Command Line Interface (CLI)',
      url: 'https://vimeo.com/566261796',
      thumbnail:
        'https://i.vimeocdn.com/video/1170803654-edabe00a945aa35cf85d9f110645afb479869b785458ec4c08831d6860e9b697-d?mw=1500&mh=844&q=70',
      duration: '04:13 mins',
    },
    jenkins: {
      index: 'jenkins',
      videoId: '561535122',
      displayName: 'Managing CI/CD Pipelines for Data',
      url: 'https://vimeo.com/561535122',
      thumbnail:
        'https://i.vimeocdn.com/video/1160647089-d49db998e329a204e7a36990e84ad35948b75e8205c719f241f0518ab269fa7b-d?mw=1500&mh=844&q=70',
      duration: '04:59 mins',
    },
    understandingDatasets: {
      index: 'understandingDatasets',
      videoId: '331881757/9e55fb7e1b',
      displayName: 'Nexsets 101',
      url: 'https://vimeo.com/331881757/9e55fb7e1b',
      thumbnail:
        'https://i.vimeocdn.com/video/777418812-9e95485ba934be6af3382384dbbf86fe4095cb0bcf10913401ef725e891fba96-d?mw=1300&mh=731&q=70',
      duration: '05:42 mins',
    },
    fileSystemRead: {
      index: 'fileSystemRead',
      videoId: '328503879/6f9f86acec',
      displayName: 'File Sources: Basic Setup',
      url: 'https://vimeo.com/328503879/6f9f86acec',
      thumbnail:
        'https://i.vimeocdn.com/video/773043662-b67b47b93a08007db081631f7a47ade4dd6896ffcfa24da3bc7d3fd598433413-d?mw=1300&mh=731&q=70',
      duration: '03:16 mins',
    },
    emailSource: {
      index: 'emailSource',
      videoId: '336852452/deaf12f0f7',
      displayName: 'Email Sources',
      url: 'https://vimeo.com/336852452/deaf12f0f7',
      thumbnail:
        'https://i.vimeocdn.com/video/783807541-373ddaf14865be0887c40ae3940516c31936217a256a240c66e6fbef6e427bc3-d?mw=1300&mh=731&q=70',
      duration: '02:42 mins',
    },
    snowflakeRead: {
      index: 'snowflakeRead',
      videoId: '318319440/da91fb112e',
      displayName: 'Database Source: Snowflake',
      url: 'https://vimeo.com/318319440/da91fb112e',
      thumbnail:
        'https://i.vimeocdn.com/video/760699706-0d4839217be0001c84b7bf511917b6caad3c95d25b3cc0ab9c5956890660aab9-d?mw=1300&mh=849&q=70',
      duration: '01:57 mins',
    },
    snowflakeWrite: {
      index: 'snowflakeWrite',
      videoId: '318316648/3023b93174',
      displayName: 'Database Destination: Snowflake',
      url: 'https://vimeo.com/318316648/3023b93174',
      thumbnail:
        'https://i.vimeocdn.com/video/760696908-6491b2d6c4dc072bd7bd36d15778d25f3a8430f3ab9d703dd644f1713fadf463-d?mw=1300&mh=849&q=70',
      duration: '02:23 mins',
    },
    nexsetDesignerOverview: {
      index: 'nexsetDesignerOverview',
      videoId: '782350237',
      displayName: 'Nexset Designer Overview',
      url: 'https://vimeo.com/782350237',
      thumbnail:
        'https://i.vimeocdn.com/video/1570757960-9be8d4c1d17276c7db13e76f538f25ec822bd230bb84b067bb3bb9b84129cac2-d',
      duration: '06:15 mins',
    },
    resourceSearch: {
      index: 'resourceSearch',
      videoId: '911346836',
      displayName: 'Resource Search Interface',
      url: 'https://vimeo.com/911346836',
      thumbnail:
        'https://i.vimeocdn.com/video/1795796736-1e1a8008b06d892aeb3e2ba0c9fe235f420eb799f3a4c51ebd4e69c10df6f0b7-d',
      duration: '05:31 mins',
    },
    flowInsights: {
      index: 'flowInsights',
      videoId: '828471591',
      displayName: 'Flow Insights',
      url: 'https://vimeo.com/828471591',
      thumbnail:
        'https://i.vimeocdn.com/video/1672344031-932ec1c347e0b396006b1182959570421b6d2a2e75f8ca9271a142adb48b5f69-d?mw=1300&mh=731&q=70',
      duration: '04:53 mins',
    },
    usingEmailConnector: {
      index: 'usingEmailConnector',
      videoId: '822171537',
      displayName: 'Using The Email Connector',
      url: 'https://vimeo.com/822171537',
      thumbnail:
        'https://i.vimeocdn.com/video/1662794744-ff0e112ad4a4a663afd96c00e1c0881646b5ec870511b9d50b53e9acde9f6ff1-d',
      duration: '05:50 mins',
    },
    byoFlowGuide: {
      index: 'byoFlowGuide',
      videoId: '1053183466',
      displayName: 'BYO Flows: Quick Start Guide',
      url: 'https://vimeo.com/1053183466',
      thumbnail:
        'https://i.vimeocdn.com/video/1978303721-c0ec8cdcf66f79879daf1fa02c7926eb8226baaa4ed4c24df5e0da1cf9d0d339-d',
      duration: '04:47 mins',
    },
    directFlowGuide: {
      index: 'directFlowGuide',
      videoId: '1052431597',
      displayName: 'Direct Flow: Quick Start Guide',
      url: 'https://vimeo.com/1052431597',
      thumbnail:
        'https://i.vimeocdn.com/video/1977411964-1f63cf118cf6d4268bdd18dac606e389b132d189660186340c7870deb09d0b8c-d',
      duration: '04:32 mins',
    },
    eltFlowGuide: {
      index: 'eltFlowGuide',
      videoId: '1051616583',
      displayName: 'ELT Flows: Quick Start Guide',
      url: 'https://vimeo.com/1051616583',
      thumbnail:
        'https://i.vimeocdn.com/video/1976447181-f2515e40728c7e84653a3d53a8c83862bb8e5c976f461e05d88737eeb4ef9e2e-d',
      duration: '04:21 mins',
    },
    flowVisOrchestration: {
      index: 'flowVisOrchestration',
      videoId: '1041259594',
      displayName: 'Flow Visualization & Orchestration',
      url: 'https://vimeo.com/1041259594',
      thumbnail:
        'https://i.vimeocdn.com/video/1963987035-76217941f4335a6970d81c4006cd5339b17250926f47a7bcf6549c7c41c9b74b-d',
      duration: '02:09 mins',
    },
    privateDataProductMarketplace: {
      index: 'privateDataProductMarketplace',
      videoId: '1033584514',
      displayName: 'Private Data Product Marketplace',
      url: 'https://vimeo.com/1033584514',
      thumbnail:
        'https://i.vimeocdn.com/video/1954731679-c875b202a0d1b2756a9c80cbdf044330abf588c2a029cdf87b7edfc3f5545bf0-d',
      duration: '02:01 mins',
    },
    replicationFlowGuide: {
      index: 'replicationFlowGuide',
      videoId: '992288716',
      displayName: 'Replication Flows: Quick Start Guide',
      url: 'https://vimeo.com/992288716',
      thumbnail:
        'https://i.vimeocdn.com/video/1908175091-49765b62bd26b5a66a78abb31d852694d906e883dae9b02be7b8fb3cc81b215e-d',
      duration: '03:36 mins',
    },
    dbCdcFlowGuide: {
      index: 'dbCdcFlowGuide',
      videoId: '992144173',
      displayName: 'DB-CDC Flows: Quick Start Guide',
      url: 'https://vimeo.com/992144173',
      thumbnail:
        'https://i.vimeocdn.com/video/1908021794-a2eecb24a830ef5f9ed7fc40f228d87e864a8016de2bd84389d01019ef58ddbf-d',
      duration: '05:06 mins',
    },
    sparkEtlFlowGuide: {
      index: 'sparkEtlFlowGuide',
      videoId: '989041598',
      displayName: 'Spark ETL Flows: Quick Start Guide',
      url: 'https://vimeo.com/989041598',
      thumbnail:
        'https://i.vimeocdn.com/video/1904737111-cca71cc37e9b4b5c4706ffa2d23e17e7489880276fb221c56c15a3819123528c-d',
      duration: '05:37 mins',
    },
    ragFlowGuide: {
      index: 'ragFlowGuide',
      videoId: '1069261133',
      displayName: 'RAG Flows: Quick Start Guide',
      url: 'https://vimeo.com/1069261133',
      thumbnail:
        'https://i.vimeocdn.com/video/1997548347-c17153962137bb5b63df4e8ca14ecab49d0b1de0c2437efd9492ba25876574ce-d',
      duration: '07:28 mins',
    },
  },
};
